(function () {
  'use strict';

  if (window.__amourStockDeliveryReady) return;
  window.__amourStockDeliveryReady = true;

  var data = window.AmourStockData;
  if (!data || !data.variants) return;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function isoDate(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function addDays(base, days) {
    var date = new Date(base.getFullYear(), base.getMonth(), base.getDate(), 12, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatDateRange(start, end) {
    var locale = document.documentElement.lang || 'en';
    var includeYear = start.getFullYear() !== end.getFullYear() || start.getFullYear() !== new Date().getFullYear();
    var format = new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'short', year: includeYear ? 'numeric' : undefined});
    return format.format(start) + ' – ' + format.format(end);
  }

  function variantSignature(root, variant) {
    return [root.getAttribute('data-product-handle') || ''].concat(variant && variant.options || []).join('\u001f');
  }

  function recordFor(root, variant) {
    if (!variant || !variant.id) return null;
    var direct = data.variants[String(variant.id)];
    if (direct) return direct;
    return data.signatures && data.signatures[variantSignature(root, variant)] || 'm';
  }

  function init(root) {
    if (!root || root.dataset.amourStockBound === 'true' || root.hasAttribute('data-jewellery-pdp')) return;
    var form = root.querySelector('form.ovale-form');
    if (!form) return;
    root.dataset.amourStockBound = 'true';

    var summary = root.querySelector('[data-amour-stock-summary]');
    var estimateNode = root.querySelector('.ovale-delivery__estimate');
    var active = null;
    var enforcing = false;
    var renderSequence = 0;
    var productNode = root.querySelector('[data-ovale-product-json]');
    var productVariants = [];
    try {
      productVariants = JSON.parse(productNode && productNode.textContent || '{}').variants || [];
    } catch (error) { /* The selected-variant path remains available. */ }

    function hiddenInput(name) {
      var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.className = 'amour-stock-property';
        form.prepend(input);
      }
      return input;
    }

    function setHidden(name, value, enabled) {
      var input = hiddenInput(name);
      input.value = enabled ? value : '';
      input.disabled = !enabled;
    }

    function estimatedInputs() {
      return Array.prototype.slice.call(form.querySelectorAll('input[name="properties[Estimated delivery between]"]'));
    }

    function enforceProperties() {
      if (enforcing) return;
      enforcing = true;
      try {
        var enabled = Boolean(active);
        var estimated = estimatedInputs();
        if (!estimated.length) {
          estimated.push(hiddenInput('properties[Estimated delivery between]'));
        }
        estimated.forEach(function (input) {
          input.value = enabled ? active.range : '';
          input.disabled = !enabled;
          input.setAttribute('data-amour-stock-owned', 'true');
        });
        setHidden('properties[_Amour stock state]', enabled ? active.state : '', enabled);
        setHidden('properties[_Amour delivery start]', enabled ? active.startIso : '', enabled);
        setHidden('properties[_Amour delivery end]', enabled ? active.endIso : '', enabled);
        setHidden('properties[_Amour delivery display]', enabled ? active.range : '', enabled);
        setHidden('properties[_Amour stock source]', enabled ? active.source : '', enabled);
      } finally {
        enforcing = false;
      }
    }

    function applyRecord(record, revision) {
      if (!record) {
        active = null;
        root.removeAttribute('data-amour-stock-state');
        if (summary) {
          summary.removeAttribute('data-amour-stock-preview');
          summary.hidden = true;
          summary.style.display = 'none';
        }
        if (estimateNode) estimateNode.textContent = '';
        enforceProperties();
        return;
      }

      var inStock = record === 'i';
      var startDays = inStock ? 5 : 7;
      var endDays = inStock ? 10 : 21;
      var now = new Date();
      var start = addDays(now, startDays);
      var end = addDays(now, endDays);
      var range = formatDateRange(start, end);
      active = {
        state: inStock ? 'in_stock' : 'made_to_order',
        range: range,
        startIso: isoDate(start),
        endIso: isoDate(end),
        source: revision == null ? data.sourceStockDate : 'live:' + revision
      };
      root.setAttribute('data-amour-stock-state', active.state);
      if (estimateNode) estimateNode.textContent = range;
      if (summary) {
        summary.removeAttribute('data-amour-stock-preview');
        summary.hidden = false;
        summary.style.display = '';
      }
      enforceProperties();
    }

    function applyUnselectedRecord(record) {
      var inStock = record === 'i';
      var now = new Date();
      var range = formatDateRange(addDays(now, inStock ? 5 : 7), addDays(now, inStock ? 10 : 21));
      active = null;
      root.removeAttribute('data-amour-stock-state');
      if (estimateNode) estimateNode.textContent = range;
      if (summary) {
        summary.setAttribute('data-amour-stock-preview', range);
        summary.hidden = false;
        summary.style.display = '';
      }
      // A preview date is never submitted as a selected variant's cart property.
      enforceProperties();
    }

    function renderUnselected(sequence) {
      var variants = productVariants.filter(function (variant) {
        return variant && variant.id && !(variant.options || []).some(function (option) {
          return /select\s+(the\s+)?ring\s+size|choose\s+(a\s+)?ring\s+size/i.test(String(option));
        });
      });
      if (!variants.length) return applyRecord(null, null);
      var snapshotHasStock = variants.some(function (variant) { return recordFor(root, variant) === 'i'; });
      var live = window.AmourStockLive;
      if (!live || !live.enabled) return applyUnselectedRecord(snapshotHasStock ? 'i' : 'm');
      // Until the current stock check settles, use the existing longer window.
      applyUnselectedRecord('m');
      live.get(variants.map(function (variant) { return variant.id; })).then(function (records) {
        if (sequence !== renderSequence) return;
        var anyInStock = variants.some(function (variant) {
          return records[String(variant.id)] && records[String(variant.id)].stockState === 'in_stock';
        });
        applyUnselectedRecord(anyInStock ? 'i' : 'm');
      }).catch(function () {
        if (sequence === renderSequence) applyUnselectedRecord('m');
      });
    }

    function render(variant) {
      var live = window.AmourStockLive;
      var sequence = ++renderSequence;
      if (!variant || !variant.id) return renderUnselected(sequence);
      var record = recordFor(root, variant);
      if (!live || !live.enabled || !record || !variant || !variant.id) {
        applyRecord(record, null);
        return;
      }
      // Never show a stale short promise while a fresh stock check is pending.
      applyRecord('m', null);
      live.get([variant.id]).then(function (records) {
        if (sequence === renderSequence) {
          var current = records[String(variant.id)];
          applyRecord(current.stockState === 'in_stock' ? 'i' : 'm', current.revision);
        }
      }).catch(function () {
        if (sequence === renderSequence) applyRecord('m', null);
      });
    }

    root.addEventListener('ovale:variant:change', function (event) {
      render(event.detail && event.detail.variant || null);
    });

    form.addEventListener('submit', enforceProperties, true);
    if (window.MutationObserver) {
      new MutationObserver(function () { enforceProperties(); }).observe(form, {childList: true, subtree: true});
    }
    window.setInterval(function () {
      if (!document.hidden && root.isConnected) enforceProperties();
    }, 500);

    window.setTimeout(function () {
      var hiddenId = form.querySelector('[data-ovale-variant-id]');
      var size = form.querySelector('[data-ovale-size-select]');
      if (!hiddenId || !hiddenId.value || (size && !size.value)) return render(null);
      try {
        var product = JSON.parse(productNode && productNode.textContent || '{}');
        var variant = (product.variants || []).find(function (candidate) { return String(candidate.id) === String(hiddenId.value); });
        render(variant || null);
      } catch (error) {
        render(null);
      }
    }, 100);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ovale-pdp]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
